import styled from "styled-components";


export const ServicesWrapper = styled.div`
    max-width: 1000px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    align-items: center;
    grid-gap: 16px;
    // padding: 0 50px;

    @media screen and (max-width: 1000px) {
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 0 20px;
    }
`;

export const ServicesCard = styled.div`
    background: #FCFCFC;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    border-radius: 10px;
    max-height: 1200px;
    padding: 15px;
    box-shadow: 0 1px 3px egba(0,0,0,0.2);
    transition: all 0.2s ease-in-out;
    margin-bottom: 2rem;

    &:hover {
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }
`;

export const ServicesIcon = styled.img`
    height: 120px;
    width: 120px;
    margin-bottom: 10px;
`;

export const ServicesH1 = styled.h1`
    font-size: 2.5rem;
    margin-bottom: 64px;

    @media screen and (max-width: 480px) {
        font-size: 2rem;
    }
`;

export const ServicesH2 = styled.h2`
    font-size: 1.1rem;
    margin-bottom: 10px;
    color: #115757;
`;

export const ServicesP = styled.p`
    font-size: 1rem;
    text-align: center;
    line-height: 1.5rem;
    color: #000
`;
